import { takeLatest } from 'redux-saga/effects';

import { handleClaimReward, handleFetchClaimStatus, handleScanQr, handleValidateMobile } from './campaignSaga';
import sagaActions from '../../actions/index';

export function* CampgainListSaga() {
  yield takeLatest(sagaActions.SCAN_QR, handleScanQr);
  yield takeLatest(sagaActions.VALIDATE_MOBILE, handleValidateMobile);
  yield takeLatest(sagaActions.CLAIM_REWARD, handleClaimReward);
  yield takeLatest(sagaActions.FETCH_CLAIM_STATUS, handleFetchClaimStatus);
}
